module.exports = __webpack_public_path__ + "img/sr-postcard.4b1be8f9.png";